var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighDefinition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.3,121.9h-25V250h25c34.4,0,50-21.9,50-62.5C384.4,143.8,362.5,121.9,331.3,121.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,0A62.65,62.65,0,0,0,0,62.5v250A62.65,62.65,0,0,0,62.5,375h375A62.65,62.65,0,0,0,500,312.5V62.5A62.65,62.65,0,0,0,437.5,0ZM234.4,93.8V281.3H196.9V200H118.8v81.3H81.3V93.8h37.5v75h78.1v-75Zm34.4,187.5V93.8h68.8c56.2,0,84.4,34.4,84.4,93.8s-28.1,93.8-84.4,93.8H268.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighDefinition);
export default __webpack_public_path__ + "static/media/high-definition.9886bad16012b913e05250aeda640f8c.svg";
export { ForwardRef as ReactComponent };